module.exports = function SignalError(code, message) {
  this.code = code;
  this.message = message;

  // Undocumented. Left in for backwards compatibility:
  this.reason = message;
};



// WEBPACK FOOTER //
// ./src/js/RaptorSession/raptor/SignalError.js